export const beadingThreadWiresLevelThree = [
    {
        "name": "Elastic Thread",
        "categoryId": "elastic_thread",
        "parentCategoryName": "Beading Thread",
        "parentCategoryId": "beading_thread",
        "level": 3
    },
    {
        "name": "Non Elastic Thread",
        "categoryId": "non_elastic_thread",
        "parentCategoryName": "Beading Thread",
        "parentCategoryId": "beading_thread",
        "level": 3
    },
    {
        "name": "Silk Thread",
        "categoryId": "silk_thread",
        "parentCategoryName": "Beading Thread",
        "parentCategoryId": "beading_thread",
        "level": 3
    },
    {
        "name": "Leather Cord",
        "categoryId": "leather_cord",
        "parentCategoryName": "Beading Thread",
        "parentCategoryId": "beading_thread",
        "level": 3
    },
    {
        "name": "Necklace Dori",
        "categoryId": "necklace_dori",
        "parentCategoryName": "Beading Thread",
        "parentCategoryId": "beading_thread",
        "level": 3
    },
    {
        "name": "Tiger Tail Wire",
        "categoryId": "tiger_tail_wire",
        "parentCategoryName": "Beading Wire",
        "parentCategoryId": "beading_wire",
        "level": 3
    },
    {
        "name": "Brass Wire",
        "categoryId": "brass_wire",
        "parentCategoryName": "Beading Wire",
        "parentCategoryId": "beading_wire",
        "level": 3
    },
    {
        "name": "Beaded Chain",
        "categoryId": "chain",
        "parentCategoryName": "chain",
        "parentCategoryId": "chain",
        "level": 3
    },
    {
        "name": "Chains",
        "categoryId": "chain",
        "parentCategoryName": "chain",
        "parentCategoryId": "chain",
        "level": 3
    }

]
